import { createContext, type Dispatch, useContext } from 'react';

import { type AdvancedFiltersConfig } from '../types/config.types';
import { type AdvancedFiltersReducerActions } from '../types/reducer.types';
import { type AdvancedFiltersPrivateState } from '../types/state.types';

type AdvancedFiltersInternalContextValue = {
  state: AdvancedFiltersPrivateState;
  dispatch: Dispatch<AdvancedFiltersReducerActions>;
  config: AdvancedFiltersConfig;
};

export const AdvancedFiltersInternalContext =
  createContext<AdvancedFiltersInternalContextValue | null>(null);

export const useAdvancedFiltersInternalContext = () => {
  const context = useContext(AdvancedFiltersInternalContext);

  if (!context) {
    throw new Error(
      'useAdvancedFiltersInternalContext must be used within a AdvancedFiltersInternalContextProvider',
    );
  }

  return context;
};
